const media = {
  TABLET: `(max-width: 1000px)`,
  MOBILE: `(max-width: 800px)`,
};

export default media;
